/* eslint-disable no-barrel-files/no-barrel-files */
// TODO: De-barrel-ize
export { BreadcrumbBar } from './BreadcrumbBar'
